export class SettingsColumn {
    public field: string;
    public width: number;
}
